export default "__VITE_ASSET__C5o8aQNX__"